import { NavItem } from '@shared/interfaces/nav/nav-item';

export const settingsNavItem: NavItem[] = [
  {
    title: 'settings.profile',
    route: '/settings/'
  },
  {
    title: 'settings.table',
    route: '/settings/table'
  },
]
